import React from 'react'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import tejaswinidoc from '../../../../assets/images/Doctorsimages/dr.teju.png' 
import favicon from "./../../../../assets/images/favicon.ico"
import AutoScrollImageRow from '../../AdvancedTreatmentsforHome/AutoScrollImageRow'
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const TejaswiniDoc = () => {
  const navigate = useNavigate(); 

  useEffect(() => {
    document.title = "Dr. Tejaswini K | Best Dentist & Aesthetics Consultant in Gachibowli Hyderabad";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Consult Dr. Tejaswini K (BDS), a trusted consultant dentist and aesthetics expert in Gachibowli, Hyderabad. With 2+ years of experience, she specializes in empathetic, precision-based dental care and personalized smile enhancements. Book today."
      );
    }

    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "best dentist in Gachibowli Hyderabad, dental clinic in Gachibowli, aesthetic dentist in Hyderabad, female dentist in Gachibowli, consultant dentist near me, smile design expert Hyderabad, Kamineni dental graduate doctor, dental aesthetics Gachibowli, precision dental care Hyderabad, cosmetic dentistry Gachibowli, top dentist in Gachibowli, consultant dental surgeon near me, aesthetic dental treatments Hyderabad, personalized dental care Gachibowli, dentist with 2 years experience Hyderabad"
      );
    }

    const existingCanonical = document.querySelector("link[rel='canonical']");
    const canonicalUrl = "https://www.h-cura.com/doctors/dr-tejaswini-aesthetic-dental-consultant-gachibowli-hyderabad";
    if (existingCanonical) {
      existingCanonical.setAttribute("href", canonicalUrl);
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute("href", canonicalUrl);
      document.head.appendChild(canonicalLink);
    }

    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }
  }, []);

  const handleDownloadPdf = () => {
    const container = document.querySelector('.veenadoc');
    container.classList.add('veenadoc-pdf-mode');
    const originalStyles = new Map();
    const allElements = container.querySelectorAll('*');

    allElements.forEach(el => {
      originalStyles.set(el, {
        transition: el.style.transition,
        animation: el.style.animation,
        transform: el.style.transform,
        filter: el.style.filter
      });
      el.style.transition = 'none';
      el.style.animation = 'none';
      el.style.transform = 'none';
      el.style.filter = 'none';
    });

    const heroSection = container.querySelector('.veenadoc-hero-section');
    if (heroSection) {
      heroSection.style.minHeight = 'auto';
      heroSection.style.padding = '40px 0';
    }

    // Fix: Ensure images are visible for capture
    const images = container.querySelectorAll('img');
    images.forEach(img => {
      img.style.opacity = '1';
    });

    setTimeout(() => {
      html2canvas(container, {
        scale: 2,
        dpi: 300,
        useCORS: true,
        allowTaint: true,
        letterRendering: true,
        backgroundColor: '#ffffff',
        logging: false,
        windowWidth: container.scrollWidth,
        windowHeight: container.scrollHeight,
        scrollY: -window.scrollY,
        scrollX: -window.scrollX,
        imageTimeout: 0,
        removeContainer: false
      }).then(canvas => {
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          if (original) {
            el.style.transition = original.transition;
            el.style.animation = original.animation;
            el.style.transform = original.transform;
            el.style.filter = original.filter;
          }
        });

        if (heroSection) {
          heroSection.style.minHeight = '';
          heroSection.style.padding = '';
        }

        const imgData = canvas.toDataURL('image/jpeg', 0.95);
        const pdf = new jsPDF('p', 'mm', 'a4', true);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = pdf.internal.pageSize.getHeight();
        const canvasWidth = canvas.width;
        const canvasHeight = canvas.height;
        const marginLeft = 10;
        const marginRight = 10;
        const availableWidth = pdfWidth - marginLeft - marginRight;
        const scaleFactor = availableWidth / canvasWidth;
        const imgWidth = canvasWidth * scaleFactor;
        const imgHeight = canvasHeight * scaleFactor;
        const pages = Math.ceil(imgHeight / pdfHeight);

        for (let i = 0; i < pages; i++) {
          if (i > 0) pdf.addPage();
          pdf.addImage(imgData, 'JPEG', marginLeft, -i * pdfHeight, imgWidth, imgHeight, undefined, 'FAST');
        }
        pdf.save('Dr_Tejaswini_K_Profile.pdf');
      }).catch(error => {
        console.error('Error generating PDF:', error);
        container.classList.remove('veenadoc-pdf-mode');
        allElements.forEach(el => {
          const original = originalStyles.get(el);
          if (original) {
            el.style.transition = original.transition;
            el.style.animation = original.animation;
            el.style.transform = original.transform;
            el.style.filter = original.filter;
          }
        });
      });
    }, 100);
  };

  return (
    <>
      <div className="veenadoc">
        {/* Hero Section */}
        <div className="veenadoc-hero-section">
          <div className="veenadoc-hero-background">
            <div className="veenadoc-wave-pattern">
              <svg viewBox="0 0 1200 320" className="veenadoc-wave-svg" preserveAspectRatio="none">
                <path d="M0,96L48,112C96,128,192,160,288,186.7C384,213,480,235,576,213.3C672,192,768,128,864,128C960,128,1056,192,1152,208C1248,224,1344,192,1392,176L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z" fill="rgba(46, 125, 50, 0.1)"></path>
              </svg>
            </div>
            <div className="veenadoc-floating-shapes">
              <div className="veenadoc-shape veenadoc-shape-1"></div>
              <div className="veenadoc-shape veenadoc-shape-2"></div>
              <div className="veenadoc-shape veenadoc-shape-3"></div>
              <div className="veenadoc-shape veenadoc-shape-4"></div>
            </div>
          </div>

          <div className="veenadoc-container">
            <div className="veenadoc-hero-content">
              <div className="veenadoc-hero-left">
                <h1 className="veenadoc-hero-title">
                  <span className="veenadoc-title-highlight">Dr. Tejaswini K</span>
                  <span className="veenadoc-title-credentials">(BDS)</span>
                  <span className="veenadoc-title-location">Gachibowli, Hyderabad</span>
                </h1>

                <div className="veenadoc-hero-description">
                  <p>
                    Recognized as one of the premier dental professionals in Gachibowli, Hyderabad, serving as a dedicated 
                    Consultant Dentist and Aesthetics specialist. With more than <strong>2</strong> years of clinical 
                    experience, she provides comprehensive oral health solutions that seamlessly blend clinical necessity 
                    with aesthetic perfection.
                  </p>
                </div>

                <div className="veenadoc-hero-actions">
                  <button className="veenadoc-btn-primary-gradient" onClick={() => navigate('/bookconsultation')}>
                    <span className="veenadoc-btn-icon">📞</span>
                    <span>Book Consultation</span>
                    <div className="veenadoc-btn-shine"></div>
                  </button>
                </div>
              </div>

              <div className="veenadoc-hero-right">
                <div className="veenadoc-doctor-showcase">
                  <div className="veenadoc-doctor-frame">
                    <div className="veenadoc-frame-glow"></div>
                    <div className="veenadoc-image-container">
                      <img src={tejaswinidoc} alt="Dr. Tejaswini K - Best Dentist & Aesthetics Consultant in Gachibowli Hyderabad" className="veenadoc-doctor-image" title='Dr. Tejaswini K – Best Dentist & Aesthetics Consultant in Gachibowli Hyderabad' />
                      <div className="veenadoc-image-overlay"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Article Content */}
        <div className="veenadoc-article-section">
          <div className="veenadoc-container">
            <div className="veenadoc-article-layout">
              <div className="veenadoc-article-main">
                
                <div className="veenadoc-article-block">
                  <h2>About Dr. Tejaswini K</h2>
                  <p>
                    Dr. Tejaswini K earned her degree from the prestigious Kamineni Institute of Dental Sciences, a foundation 
                    that instilled in her the rigorous medical standards and technical proficiency she brings to her practice 
                    today in the heart of Hyderabad’s tech corridor.
                  </p>
                  <p>
                    Patients seeking the top dentist in Gachibowli often choose Dr. Tejaswini for her unique ability to combine 
                    advanced dental science with a compassionate, patient-centric touch. Over her years of practice, she has 
                    built a trusted reputation for creating a comfortable environment where patients feel heard and valued.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Professional Journey & Expertise</h2>
                  <p>
                    Dr. Tejaswini’s professional journey is defined by her role as a consultant, where she has successfully 
                    managed a diverse range of cases with long-lasting outcomes. Her expertise extends beyond traditional 
                    dentistry into the realm of aesthetics, allowing her to offer modern solutions for smile design and facial harmony.
                  </p>
                  <p>
                    Patients searching for a "consultant dentist near me" find in Dr. Tejaswini a professional who does not 
                    just treat teeth, but focuses on the overall well-being and confidence of the individual through a refined, 
                    experienced lens.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Quick Information</h3>
                  <div className="veenadoc-info-grid">
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Qualification:</span>
                      <span className="veenadoc-info-value">BDS</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Experience:</span>
                      <span className="veenadoc-info-value">2+ Years</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Specialization:</span>
                      <span className="veenadoc-info-value">Dentistry & Aesthetics</span>
                    </div>
                    <div className="veenadoc-info-item">
                      <span className="veenadoc-info-label">Location:</span>
                      <span className="veenadoc-info-value">Gachibowli, Hyderabad</span>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Precision Dental Care</h2>
                  <p>
                    Her focus on precision ensures that every procedure—from routine fillings to advanced aesthetic work—is 
                    executed to the highest medical standards. She emphasizes the importance of preventive care and patient 
                    education, guiding her patients through hygiene practices that ensure long-term oral health.
                  </p>
                  <p>
                    In the bustling area of Gachibowli, Dr. Tejaswini has become a trusted name for those seeking a holistic 
                    approach to dental wellness, catering to patients of all ages with a respectful and professional demeanor.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Specialized Trichology & Hair Care Solutions</h2>
                  <p>
                    Dr. Tejaswini has gained recognition as a trichology doctor in Hyderabad specializing in hair fall, dandruff, scalp conditions, hair thinning, premature greying, alopecia, and hair regrowth treatments. She also provides advanced hair therapies such as PRP (Platelet-Rich Plasma), GFC (Growth Factor Concentrate), Mesotherapy, Stem Cell Therapy, Laser Hair Therapy and exosome to ensure effective and long-lasting results.
                  </p>
                  <p>
                    Her expertise ensures that patients not only regain healthy hair but also confidence and peace of mind.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>Aesthetic Dentistry & Smile Design</h2>
                  <p>
                    One of her primary areas of expertise is aesthetic dentistry, where she helps patients achieve the smiles 
                    they have always desired. Many individuals looking for the best aesthetic dentist in Hyderabad consult 
                    Dr. Tejaswini for her skill in balancing functional health with visual beauty.
                  </p>
                  <p>
                    Her treatments are designed to be minimally invasive yet highly effective, utilizing modern techniques to 
                    restore health and enhance radiance without compromising the natural structure of the teeth.
                  </p>
                </div>

                <div className="veenadoc-article-block">
                  <h2>What Makes Dr. Tejaswini Unique</h2>
                  <p>
                    What sets Dr. Tejaswini apart is her dual focus on clinical precision and aesthetic artistry. While many 
                    practitioners focus solely on the medical aspect of dentistry, she integrates aesthetic considerations 
                    into every procedure.
                  </p>
                  <p>
                    This dual specialization ensures that her patients leave her clinic not only with healthy teeth but with 
                    a renewed sense of confidence. Whether you are searching for a smile makeover specialist or a reliable 
                    consultant for general dental health, her profile stands out as a beacon of trust.
                  </p>
                </div>

                <div className="veenadoc-article-block veenadoc-conclusion-block">
                  <h2>Choose Dr. Tejaswini K for a Radiant Smile</h2>
                  <p>
                    Choosing Dr. Tejaswini K means entrusting your smile to a doctor who views healthcare as a partnership. 
                    She provides the assurance of safe, evidence-based treatments delivered with the kindness of a true healer.
                  </p>
                  <p>
                    For anyone in Gachibowli or the wider Hyderabad area looking for exceptional dental and aesthetic care, 
                    Dr. Tejaswini is the professional who brings together medical excellence and artistic vision.
                  </p>
                  <p className="veenadoc-mission-statement">
                    <strong>Her mission:</strong> To empower every patient with a healthy, beautiful smile and the confidence 
                    that comes with it.
                  </p>
                </div>
              </div>

              {/* Sidebar */}
              <div className="veenadoc-article-sidebar">
                <div className="veenadoc-article-block veenadoc-philosophy-block">
                  <div className="veenadoc-philosophy-quote">
                    <div className="veenadoc-quote-icon">💫</div>
                    <blockquote>
                      "I believe in treating every patient with empathy, precision, and personalized care"
                    </blockquote>
                    <p className="veenadoc-quote-attribution">— Dr. Tejaswini K's Philosophy of Care</p>
                  </div>
                  <p>
                    She recognizes that many individuals feel anxious about dental visits, and she goes above and beyond to 
                    create a calm, welcoming environment by prioritizing empathy and personalized care.
                  </p>
                </div>

                <div className="veenadoc-sidebar-card">
                  <h3>Practice Location</h3>
                  <div className="veenadoc-location-item">
                    <div className="veenadoc-location-icon">📍</div>
                    <div className="veenadoc-location-details">
                      <h4>Gachibowli, Hyderabad</h4>
                      <p>Primary Practice Location</p>
                    </div>
                  </div>
                </div>

                <div className="veenadoc-sidebar-card veenadoc-cta-card">
                  <h3>Book Your Consultation</h3>
                  <p>Experience precision dental care with Dr. Tejaswini's empathetic approach.</p>
                  <button className="veenadoc-sidebar-btn-primary" onClick={() => window.location.href = 'tel:+919964688333'}>
                    <span>📞</span>
                    <span>Schedule Appointment</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AutoScrollImageRow/>

      <div className="bangloregfcblog-download-section">
        <button className="bangloregfcblog-download-button" onClick={handleDownloadPdf}>
          Download This Doctor profile as PDF
        </button>
      </div>
    </>
  )
}

export default TejaswiniDoc
